import { render, staticRenderFns } from "./ShelfQty.vue?vue&type=template&id=264b857b&scoped=true&"
import script from "./ShelfQty.vue?vue&type=script&lang=js&"
export * from "./ShelfQty.vue?vue&type=script&lang=js&"
import style0 from "./ShelfQty.vue?vue&type=style&index=0&id=264b857b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b857b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
